import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import {
	borderNeutralModerate,
	neutralPrimary,
	primaryColor,
	textNeutralSecondary,
} from "../../../core/theme";

export interface SelectAutocompleteItem {
	value: string;
	label: string;
}

export interface SelectAutocompleteProps {
	items: SelectAutocompleteItem[];
	label?: string;
	placeholder?: string;
	loading?: boolean;
	name?: string;
	value?: string[] | string;
	onChange?: (value: string) => void;
}

const labelStyle: SxProps<Theme> = {
	display: "block",
	color: textNeutralSecondary,
	fontSize: "14px",
	lineHeight: "20px",
	marginBottom: "8px",
};

const inputStyle: SxProps<Theme> = {
	backgroundColor: "white",
	"& .MuiOutlinedInput-root": {
		borderRadius: 0,
		minHeight: "40px",
		padding: "2px 8px",
		color: neutralPrimary,
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: borderNeutralModerate,
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: primaryColor,
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: primaryColor,
			borderWidth: "2px",
		},
	},
};

const SelectAutocomplete = ({
	items,
	label,
	placeholder,
	loading = false,
	name,
	value = "",
	onChange = () => {},
}: SelectAutocompleteProps) => {
	const selectedValue = Array.isArray(value) ? value[0] : value;
	const selectedOption =
		items.find((item) => item.value === selectedValue) ?? null;

	return (
		<Box>
			{label && (
				<Typography component="label" sx={labelStyle}>
					{label}
				</Typography>
			)}
			<Autocomplete
				data-testid={`autocomplete_${name}`}
				options={items}
				value={selectedOption}
				loading={loading}
				getOptionLabel={(option) => option.label}
				isOptionEqualToValue={(option, selected) =>
					option.value === selected.value
				}
				onChange={(_event, newValue) =>
					onChange(newValue ? newValue.value : "")
				}
				sx={inputStyle}
				renderInput={(params) => (
					<TextField
						{...params}
						name={name}
						placeholder={placeholder}
					/>
				)}
			/>
		</Box>
	);
};

export default SelectAutocomplete;
